import { Button, Table } from "antd";
import { PaymentAdditionsViewModel } from "../../../interfaces";
import { capitalizeWords } from "../../../utils";
import { statusDict } from "./AddonsForm";
import { DeleteOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../interfaces/users";
import { api } from "../../../config";
import { Dispatch, SetStateAction } from "react";
import { toast } from "react-toastify";

interface AddonsTableProps {
  readOnly?: boolean;
  paymentAdditions: PaymentAdditionsViewModel[];
  ticketId: number;
  setAdditions?: Dispatch<SetStateAction<PaymentAdditionsViewModel[]>>
  refetch?: () => void
}

export const AddonsTable = ({
  readOnly,
  paymentAdditions,
  ticketId,
  setAdditions,
  refetch
}: AddonsTableProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);

     const deleteAdditional = async (ticketId: number, id: number) => {
    await api(token)
      .delete(`payment/additions/${id}`)
      .then(() => {
        const tempData = paymentAdditions.filter((item) => item.id !== id);
        refetch?.()
        setAdditions?.(tempData);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Ocorreu um erro ao deletar o adicional");
      });
  };

  return (
    <Table
      size="small"
      dataSource={paymentAdditions || []}
      rowKey="description"
      pagination={false}
    >
      <Table.Column
        title="Descrição"
        dataIndex={["description"]}
        key="description"
        render={(name) => capitalizeWords(name)}
      />
      <Table.Column title="Valor" dataIndex="value" key="value" />
      <Table.Column
        title="Situação"
        dataIndex={["status"]}
        key="status"
        render={(name) => statusDict[name as keyof typeof statusDict]}
      />
      {!readOnly && (
        <Table.Column
          title=""
          key="actions"
          render={(_, { id }) => (
            <>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                size={"middle"}
                onClick={() => deleteAdditional(ticketId, id)}
              />
            </>
          )}
        />
      )}
    </Table>
  );
};
